import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSortModule } from "@angular/material/sort";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "src/app/common/pipes/pipes.module";
import { TabsComponent } from "src/app/shared/ui/tabs/tabs.component";
import { TableFilterModule } from "src/app/slots/three-year-plan/common/components/table/components/table-filter/table-filter.module";
import { ButtonToggleModule } from "../../button-toggle/button-toggle.module";
import { PhoneNumberInputModule } from "../../form/phone-number-input/phone-number-input.module";
import { SkeletonLoaderModule } from "../../skeleton-loader/skeleton-loader.module";
import { TableModule } from "../../table/table.module";
import { BadgeComponent } from "./components/badge/badge.component";
import { AccountingNotificationSettingsEditEmailComponent } from "./components/edit/accounting/email/notification-settings-edit-email.component";
import { EnergyDataNotificationSettingsEditEmailComponent } from "./components/edit/energy-data/email/notification-settings-edit-email.component";
import { IMNotificationSettingsEditEmailComponent } from "./components/edit/incident-management/email/notification-settings-edit-email.component";
import { IMNotificationSettingsEditPhoneComponent } from "./components/edit/incident-management/phone/notification-settings-edit-phone.component";
import { KwpNotificationSettingsEditEmailComponent } from "./components/edit/kwp/email/notification-settings-edit-email.component";
import { MultiSubscriptionNewsWarningComponent } from "./components/edit/multi-subscription-news-waring/multi-subscription-news-waring.component";
import { NewsNotificationSettingsEditEmailComponent } from "./components/edit/news/email/notification-settings-edit-email.component";
import { NotificationSettingsEditComponent } from "./components/edit/notification-settings-edit.component";
import { StreetLightingNotificationSettingsEditEmailComponent } from "./components/edit/street-lighting/email/notification-settings-edit-email.component";
import { TYPNotificationSettingsEditEmailComponent } from "./components/edit/three-year-plan/email/notification-settings-edit-email.component";
import { NotificationSettingsWrapperComponent } from "./components/edit/wrapper/notification-settings-wrapper.component";
import { MultiRegionComponent } from "./components/multi-region/multi-region.component";
import { NotificationSettingsBadgeCellComponent } from "./components/notification-settings-badge-cell/notification-settings-badge-cell.component";
import { NotificationSettingsCellComponent } from "./components/notification-settings-cell/notification-settings-cell.component";
import { NotificationSettingsKWPCellComponent } from "./components/notification-settings-kwp-cell/notification-settings-kwp-cell.component";
import { NotificationSettingsTYPCellComponent } from "./components/notification-settings-typ-cell/notification-settings-typ-cell.component";
import { NotificationSettingsComponent } from "./components/notification-settings/notification-settings.component";
import { OneRegionComponent } from "./components/one-region/one-region.component";
import { SquareModule } from "./components/square/square.module";
import { NotificationSettingsTableComponent } from "./components/table/notification-settings-table.component";

const materialModules = [
  MatDialogModule,
  MatButtonToggleModule,
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatExpansionModule,
  MatDividerModule,
  MatListModule,
  MatInputModule,
  MatTableModule,
  MatFormFieldModule,
  MatSortModule
];

@NgModule({
  declarations: [
    NotificationSettingsComponent,
    MultiRegionComponent,
    OneRegionComponent,
    NotificationSettingsCellComponent,
    NotificationSettingsBadgeCellComponent,
    NotificationSettingsTYPCellComponent,
    NotificationSettingsKWPCellComponent,
    IMNotificationSettingsEditPhoneComponent,
    IMNotificationSettingsEditEmailComponent,
    TYPNotificationSettingsEditEmailComponent,
    StreetLightingNotificationSettingsEditEmailComponent,
    NewsNotificationSettingsEditEmailComponent,
    AccountingNotificationSettingsEditEmailComponent,
    EnergyDataNotificationSettingsEditEmailComponent,
    KwpNotificationSettingsEditEmailComponent,
    NotificationSettingsEditComponent,
    NotificationSettingsTableComponent,
    NotificationSettingsWrapperComponent,
    BadgeComponent,
    MultiSubscriptionNewsWarningComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PipesModule,
    TableModule,
    SquareModule,
    PhoneNumberInputModule,
    SkeletonLoaderModule,
    ButtonToggleModule,
    TableFilterModule,
    TabsComponent,
    ...materialModules
  ]
})
export class NotificationSettingsModule {}
